import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useHover } from 'javascripts/hooks/use-hover';

import { AssetImg } from 'javascripts/components/asset_img';

import styles from 'stylesheets/components/audiobook_item_button';

export function AudiobookItemButton(props) {
  const [hoverRef, isHovered] = useHover();

  function backgroundColor() {
    if (isHovered && !_.isNil(props.hoverColor)) {
      return { backgroundColor: props.hoverColor, textDecoration: 'none' };
    }
    return { backgroundColor: props.buttonColor, textDecoration: 'none' };
  }

  function renderIcon(alignIcon) {
    if (alignIcon !== props.alignIcon) {
      return null;
    }

    const icon = isHovered && !_.isNil(props.iconHover) ? props.iconHover : props.icon;
    if (_.isNil(icon)) {
      return null;
    }

    return (
      <AssetImg
        src={icon}
        attrs={{ alt: props.iconAltText, className: classNames(styles.icon, styles[props.iconSize]) }}
      />
    );
  }

  function renderButton() {
    const classes = classNames(styles.audiobookItemButton, props.className, {
      [styles.link]: props.buttonStyle === 'link',
    });

    const Component = props.href ? 'a' : 'button';
    const style = props.buttonStyle === 'default' ? backgroundColor() : null;

    return (
      <Component
        className={classes}
        href={props.href}
        onClick={props.onClick}
        ref={hoverRef}
        style={style}
        {...props.attrs}
      >
        {renderIcon('left')}
        {props.label}
        {renderIcon('right')}
      </Component>
    );
  }

  return <>{renderButton()}</>;
}

AudiobookItemButton.propTypes = {
  alignIcon: PropTypes.oneOf(['left', 'right']),
  attrs: PropTypes.object,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.string,
  iconHover: PropTypes.string,
  iconAltText: PropTypes.string,
  iconSize: PropTypes.oneOf(['small']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  buttonColor: PropTypes.string,
  hoverColor: PropTypes.string,
  buttonStyle: PropTypes.oneOf(['default', 'link']),
};

AudiobookItemButton.defaultProps = {
  alignIcon: 'left',
  attrs: {},
  fullWidth: false,
  iconAltText: '',
  iconSize: 'small',
  onClick: () => {},
  buttonStyle: 'default',
};
